const LIVE_HOST = {
  dev: "ke-dev.huaban.com",
  fat: "ke-fat.huaban.com",
  stage: "ke-stage.huaban.com",
  prod: "ke.huaban.com",
};

const MOBILE_HOST = {
  dev: "m-dev.huaban.com",
  fat: "m-fat.huaban.com",
  stage: "m-stage.huaban.com",
  prod: "m.huaban.com",
};

const GAODING_HOST = {
  dev: "dev.gaoding.com",
  fat: "fat.gaoding.com",
  stage: "stage.gaoding.com",
  prod: "gaoding.com",
};

const GAODING_UMS_HOST = {
  dev: "ums.dev.gaoding.com",
  fat: "ums-fat.gaoding.com",
  stage: "ums-stage.gaoding.com",
  prod: "ums.gaoding.com",
};

const GAODING_EDIT_HOST = {
  dev: "gd-dev.huaban.com",
  fat: "gd-fat.huaban.com",
  stage: "gd-stage.huaban.com",
  prod: "gd.huaban.com",
};

const HUABAN_ART_HOST = {
  dev: "dev.gaoding.art",
  fat: "fat.gaoding.art",
  stage: "stage.gaoding.art",
  prod: "www.gaoding.art",
};

const env = process.env.NEXT_PUBLIC_DEPLOY_ENV || "prod";
export const liveHost = LIVE_HOST[env];
export const mobileHost = MOBILE_HOST[env];
export const gaodingHost = GAODING_HOST[env];
export const gaodingUmsHost = GAODING_UMS_HOST[env];
export const gaodingEditHost = GAODING_EDIT_HOST[env];
export const huabanArtHost = HUABAN_ART_HOST[env];
